// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//const { config } = require("../assets/config/config.json");

export const environment = {
  production: false,
  // apiUrl: "",
  //apiUrl: "http://35.82.189.210/giis",
  apiUrl: "",
  imageUrl: "../../../assets/",
  // baseUrl: "giis"




  //  baseUrl: "https://gsf-career-app-dev.irepo.in",//DEV
  // imgPath: "https://gsf-career-app-dev.irepo.in/",//DEV,
  // websiteurl: "https://gsf-career-dev.irepo.in/gsg", //DEV
  // applicanturl: "https://gsf-career-applicant-dev.irepo.in"//DEV


   // baseUrl: "https://gsf-career-app-staging.irepo.in/",//STAGING
  // imgPath: "https://gsf-career-app-staging.irepo.in/",//STAGING,
  // websiteurl: "https://gsf-career-staging.irepo.in/gsg", //STAGING
  // applicanturl: "https://gsf-career-applicant-staging.irepo.in"//STAGING

   
  baseUrl: "http://careers-admin.globalschools.com",//PROD
  imgPath: "http://careers-admin.globalschools.com/",//PROD,
  websiteurl: "https://careers.globalschools.com/gsg", //PROD
  applicanturl: "https://careers-applicant.globalschools.com"//PROD

  

  // baseUrl: "http://gsf-career-app-sit.terralogic.in",//sit
  // imgPath: "http://gsf-career-app-sit.terralogic.in",//sit
  // websiteurl: "http://gsf-career-app-sit.terralogic.in/gsg"//sit


  // baseUrl: "http://gsf-career-app-uat.terralogic.in",//uat-staging
  // imgPath: "http://gsf-career-app-uat.terralogic.in",//uat-staging
  // websiteurl: "http://gsf-career-app-uat.terralogic.in/gsg"//uat-staging

  // baseUrl: "http://gsf-career-web-dev.terralogic.in",//dev-env
  // imgPath: "http://gsf-career-web-dev.terralogic.in",//dev-env
  // websiteurl: "http://gsf-career-web-dev.terralogic.in/gsg"//dev-env
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
